import { createSelector } from 'reselect'
import { State } from 'index'

const breadSelector = (state: State) => state.bread

export const getBread = createSelector([breadSelector], (state) => state.breads[0] ?? undefined)
export const getBreads = createSelector([breadSelector], (state) => state.breads)
export const getBreadLabels = createSelector([breadSelector], (state) => state.breadLabels)
export const getIsShownPrivate = createSelector([breadSelector], (state) => state.isShownPrivate)
export const getPrevEditedBread = createSelector([breadSelector], (state) => state.prevEditedBread)
